<template>
  <div class="question-view" ref="questionView">
    <FixedFontSizeSelector>
      <div class="quest" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`}`">
      <div class="title">
        <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false" />
      </div>

      <div class="ligature-list" ref="ligatureWrap">
        <div class="left">
          <div
              class="single"
              v-for="(item, idx) in showData.left"
              :key="idx"
              v-show="!(item.textValue === '' && item.imgValue === '')"
              v-drag_ligature="{ self, type: 'left', isShow: !(item.textValue === '' && item.imgValue === '') }"
              @click="clickItemLeft($event, idx)"
          >
            <div class="value" v-if="item.type === 'text'">
              <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="item.textValue" class="span" :safe="false" />
            </div>
            <div class="image" v-else :style="{ backgroundImage: `url(${item.imgValue})` }"></div>

            <div
                class="line-drop"
                data-side="left"
                :data-index="idx"
                @mousedown="dragStart($event, 'left', idx)"
                @touchstart.stop.prevent="dragStart($event, 'left', idx)"
            ></div>
          </div>
        </div>

        <div class="right">
          <div
              class="single"
              v-for="(item, idx) in showData.right"
              :key="idx"
              v-show="!(item.textValue === '' && item.imgValue === '')"
              v-drag_ligature="{ self, type: 'right', isShow: !(item.textValue === '' && item.imgValue === '') }"
              @click="clickItemRight($event, idx)"
          >
            <div
                class="line-drop"
                data-side="right"
                :data-index="idx"
                @mousedown="dragStart($event, 'right', idx)"
                @touchstart.stop.prevent="dragStart($event, 'right', idx)"
            ></div>
            <div class="value" v-if="item.type === 'text'">
              <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="item.textValue" class="span" :safe="false" />
            </div>
            <div class="image" v-else :style="{ backgroundImage: `url(${item.imgValue})` }"></div>
          </div>
        </div>
      </div>

      <div class="test-self"></div>
  </div>
  </FixedFontSizeSelector>
  </div>
</template>

<script>
import { clickMouseDown } from './pc_event'
import { clickTouchDown } from './mobile_event'
import FixedFontSizeSelector from '@/views/examination/components/dialog/FontSizeSelector'

export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  data() {
    const letter = new Array(26).fill().map((_, idx) => String.fromCharCode(65 + idx))
    return {
      mathjaxNum: 0,
      letter,
      topic: '',
      ligatureList: [],
      showData: { left: [], right: [] },
      recordPosition: [],
      storageLigature: new Map(),
      answer_results: { id: null, student_choices: [] },
      recordQuestion: {},
      limit: 0,
      self: this,

      dragInfo: {
        dragging: false,
        startPos: null,
        tempLine: null,
        dragSide: '',
        dragIndex: null,
        endPos: null
      },

      isTouchDevice: false
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  mounted() {
    this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    window.addEventListener('orientationchange', this.handleViewportChange)
    window.addEventListener('resize', this.handleViewportChange)
  },
  beforeDestroy() {
    this.unbindTouchEvents()
    this.removeGlobalTouchLock() // 组件销毁务必清理全局拦截
    window.removeEventListener('orientationchange', this.handleViewportChange)
    window.removeEventListener('resize', this.handleViewportChange)
  },
  methods: {
    handleViewportChange() {
      setTimeout(() => this.initData(), 300)
    },

    getTouchPos(e) {
      const wrap = this.$refs.ligatureWrap
      if (!wrap) return { left: 0, top: 0 }
      const rect = wrap.getBoundingClientRect()
      let clientX, clientY
      if (e.touches && e.touches.length > 0) {
        clientX = e.touches[0].clientX
        clientY = e.touches[0].clientY
      } else {
        clientX = e.clientX
        clientY = e.clientY
      }
      return {
        left: clientX - rect.left,
        top: clientY - rect.top
      }
    },

    unbindTouchEvents() {
      const wrap = this.$refs.ligatureWrap
      if (!wrap) return
      wrap.removeEventListener('mousemove', this.dragMove)
      wrap.removeEventListener('mouseup', this.dragEnd)
      wrap.removeEventListener('touchmove', this.dragMove)
      wrap.removeEventListener('touchend', this.dragEnd)
    },

    // 全局锁定触摸：拖拽期间禁止页面滚动/下拉刷新
    addGlobalTouchLock() {
      if (!this.isTouchDevice) return
      // 捕获阶段拦截 + passive:false，确保能阻止默认滚动
      document.addEventListener('touchmove', this.preventGlobalScroll, { passive: false, capture: true })
      document.body.classList.add('ligature-dragging')
    },
    removeGlobalTouchLock() {
      if (!this.isTouchDevice) return
      document.removeEventListener('touchmove', this.preventGlobalScroll, { capture: true })
      document.body.classList.remove('ligature-dragging')
    },
    preventGlobalScroll(e) {
      e.preventDefault()
    },

    dragStart(e, side, idx) {
      if (this.isTouchDevice) {
        e.stopPropagation()
        e.preventDefault()
        this.addGlobalTouchLock() // 拖拽开始，全局锁死页面滚动
      }
      const pos = this.getTouchPos(e)
      this.dragInfo = {
        dragging: true,
        startPos: pos,
        tempLine: null,
        dragSide: side,
        dragIndex: idx,
        endPos: pos
      }
      const wrap = this.$refs.ligatureWrap

      if (!this.isTouchDevice) {
        wrap.addEventListener('mousemove', this.dragMove)
        wrap.addEventListener('mouseup', this.dragEnd)
      } else {
        wrap.addEventListener('touchmove', this.dragMove, { passive: false })
        wrap.addEventListener('touchend', this.dragEnd)
      }
    },

    dragMove(e) {
      if (!this.dragInfo.dragging) return
      if (this.isTouchDevice) {
        e.preventDefault()
        e.stopPropagation()
      }

      const movePos = this.getTouchPos(e)
      this.dragInfo.endPos = movePos
      const { startPos } = this.dragInfo

      if (!this.dragInfo.tempLine) {
        const line = document.createElement('div')
        line.className = 'line-segment drag-temp-line'
        this.$refs.ligatureWrap.appendChild(line)
        this.dragInfo.tempLine = line
      }
      this.updateLineStyle(this.dragInfo.tempLine, startPos, movePos)
    },

    dragEnd() {
      const wrap = this.$refs.ligatureWrap
      const { dragSide, dragIndex, endPos } = this.dragInfo
      const allDots = Array.from(wrap.querySelectorAll('.line-drop'))
      let hitDot = null
      let minDistance = 35

      allDots.forEach(dot => {
        const dotSide = dot.dataset.side
        const dotIdx = Number(dot.dataset.index)
        if (dotSide === dragSide) return

        const rect = dot.getBoundingClientRect()
        const wrapRect = wrap.getBoundingClientRect()
        const dotX = rect.left - wrapRect.left + rect.width / 2
        const dotY = rect.top - wrapRect.top + rect.height / 2
        const dist = Math.sqrt(Math.pow(endPos.left - dotX, 2) + Math.pow(endPos.top - dotY, 2))
        if (dist < minDistance) {
          minDistance = dist
          hitDot = { side: dotSide, index: dotIdx, x: dotX, y: dotY }
        }
      })

      if (hitDot) {
        const startDot = wrap.querySelector(`.line-drop[data-side="${dragSide}"][data-index="${dragIndex}"]`)
        const startRect = startDot.getBoundingClientRect()
        const wrapRect = wrap.getBoundingClientRect()

        const pos1 = {
          left: startRect.left - wrapRect.left + startRect.width / 2,
          top: startRect.top - wrapRect.top + startRect.height / 2,
          direction: dragSide,
          key: dragIndex
        }
        const pos2 = {
          left: hitDot.x,
          top: hitDot.y,
          direction: hitDot.side,
          key: hitDot.index
        }

        this.recordPosition = [pos1, pos2]
        this.handleLigatureData()
      }

      this.unbindTouchEvents()
      if (this.dragInfo.tempLine) this.dragInfo.tempLine.remove()
      this.removeGlobalTouchLock() // 拖拽结束，恢复页面滚动

      this.dragInfo = {
        dragging: false,
        startPos: null,
        tempLine: null,
        dragSide: '',
        dragIndex: null,
        endPos: null
      }
    },

    updateLineStyle(lineDom, pos1, pos2) {
      const centerPos = {
        left: Math.round((pos1.left + pos2.left) / 2),
        top: Math.round((pos1.top + pos2.top) / 2)
      }
      const leftDiff = Math.abs(pos1.left - pos2.left)
      const topDiff = Math.abs(pos1.top - pos2.top)
      const distance = Math.round(Math.sqrt(leftDiff ** 2 + topDiff ** 2))
      const diff = { top: pos1.top - pos2.top, left: pos1.left - pos2.left }
      const rotate = Math.round(Math.atan2(diff.top, diff.left) * (180 / Math.PI))

      lineDom.style.width = `${distance}px`
      lineDom.style.top = `${centerPos.top}px`
      lineDom.style.left = `${centerPos.left - distance / 2}px`
      lineDom.style.transform = `rotate(${rotate}deg)`
    },

    onRenderComplete(i) {
      const totalText = this.showData.left.filter(item => item.type === 'text').length
          + this.showData.right.filter(item => item.type === 'text').length
      const num = 1 + totalText
      if (i === num) {
        this.$parent.loading = false
      }
    },

    resetting(next = false) {
      this.recordPosition = []
      this.storageLigature = new Map()
      if (!next) this.$emit('permissions', next)

      const lines = document.querySelectorAll('.line-segment')
      const parent = lines.length ? lines[0].parentNode : null
      for (let i = 0; i < lines.length; i++) {
        parent.removeChild(lines[i])
      }

      this.recordQuestion = {}
      this.answer_results = { id: null, student_choices: [] }
      this.limit = 0
      if (!next) this.repariRecordQuestion()
    },

    repariRecordQuestion() {
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },

    showTrueFalse() {
      const { form, recordQuestion } = this
      const answers = form.answers.map((item, idx) => {
        const val = item.value || ''
        const ids = val.split(',')
        return ids.map(i => `left-${idx}-${i}`)
      }).flat()

      if (Object.keys(recordQuestion).length === 0) return
      this.limit = 1

      for (const i in recordQuestion) {
        const val = recordQuestion[i] || ''
        const arr = val.split(',')
        for (const j of arr) {
          try {
            const leftList = document.querySelector('.ligature-list .left')
            const rightList = document.querySelector('.ligature-list .right')
            if (!leftList || !rightList) continue

            const leftItem = leftList.querySelectorAll('.single')[i]
            const rightItem = rightList.querySelectorAll('.single')[j]
            if (!leftItem || !rightItem) continue

            const leftDom = leftItem.querySelector('.line-drop')
            const rightDom = rightItem.querySelector('.line-drop')
            if (!leftDom || !rightDom) continue

            const wrapRect = this.$refs.ligatureWrap.getBoundingClientRect()
            const leftRect = leftDom.getBoundingClientRect()
            const rightRect = rightDom.getBoundingClientRect()

            const pos1 = {
              left: leftRect.left - wrapRect.left + leftRect.width / 2,
              top: leftRect.top - wrapRect.top + leftRect.height / 2,
              direction: 'left',
              key: i
            }
            const pos2 = {
              left: rightRect.left - wrapRect.left + rightRect.width / 2,
              top: rightRect.top - wrapRect.top + rightRect.height / 2,
              direction: 'right',
              key: j
            }

            this.recordPosition = [pos1, pos2]
            this.handleLigatureData()
            const existLine = document.querySelector(`.${pos1.direction}-${pos1.key}-${pos2.key}`)
            if (!existLine) this.ligature(pos1, pos2)
          } catch (err) {
            console.warn('渲染答案连线异常', err)
          }
        }
      }

      if (this.mode === 'question') return
      const allLines = document.querySelectorAll('.line-segment')
      allLines.forEach(line => line.classList.add('line-segment-error'))
      answers.forEach(key => {
        document.querySelectorAll(`.${key}`).forEach(el => el.classList.add('line-segment-success'))
      })
    },

    correctAnswer() {
      const { showData } = this
      const answerArr = []
      for (let i = 0; i < showData.left.length; i++) {
        const leftTips = showData.left[i].tips
        for (let j = 0; j < showData.right.length; j++) {
          const rightTips = showData.right[j].tips
          if (rightTips.includes(leftTips)) {
            answerArr.push([i, j])
          }
        }
      }

      answerArr.forEach(([leftIdx, rightIdx]) => {
        const leftDom = document.querySelectorAll('.ligature-list .left .single')[leftIdx].querySelector('.line-drop')
        const rightDom = document.querySelectorAll('.ligature-list .right .single')[rightIdx].querySelector('.line-drop')
        const wrapRect = this.$refs.ligatureWrap.getBoundingClientRect()
        const lRect = leftDom.getBoundingClientRect()
        const rRect = rightDom.getBoundingClientRect()

        const pos1 = {
          left: lRect.left - wrapRect.left + lRect.width / 2,
          top: lRect.top - wrapRect.top + lRect.height / 2
        }
        const pos2 = {
          left: rRect.left - wrapRect.left + rRect.width / 2,
          top: rRect.top - wrapRect.top + rRect.height / 2
        }
        this.ligature(pos1, pos2)
      })
    },

    determineCorrect() {
      const vals = [...this.storageLigature.values()]
      const res = vals.map(item => {
        const [v1, v2] = item
        return v2.tips.includes(v1.tips)
      })
      console.log('对错结果', res)
    },

    studentQuestionResult() {
      const keys = [...this.storageLigature.keys()]
      const resultMap = new Array(6).fill(null)

      keys.forEach(key => {
        const [dir, idx1, idx2] = key.split('-')
        let a = Number(idx1)
        let b = Number(idx2)
        if (dir === 'right') [a, b] = [b, a]

        if (resultMap[a]) {
          resultMap[a].value.push(b)
        } else {
          resultMap[a] = { value: [b] }
        }
      })

      this.recordQuestion = {}
      this.answer_results.student_choices = resultMap.map((item, idx) => {
        if (item) {
          const sortArr = [...new Set(item.value)].sort((x, y) => x - y)
          this.recordQuestion[idx] = sortArr.join(',')
          return { value: sortArr.join(',') }
        }
        return null
      })
    },

    clickMouseDown,
    clickTouchDown,

    clickItemLeft(e, idx) {
      const box = e.target.classList.contains('single') ? e.target : e.target.parentNode
      const dropDom = box.querySelector('.line-drop')
      const wrapRect = this.$refs.ligatureWrap.getBoundingClientRect()
      const dropRect = dropDom.getBoundingClientRect()

      const pos = {
        left: dropRect.left - wrapRect.left + dropRect.width / 2,
        top: dropRect.top - wrapRect.top + dropRect.height / 2,
        direction: 'left',
        key: idx
      }

      const existIndex = this.recordPosition.findIndex(p => p.direction === 'left')
      if (existIndex > -1) {
        this.recordPosition[existIndex] = pos
      } else {
        this.recordPosition.push(pos)
      }

      if (this.recordPosition.length === 2) {
        this.handleLigatureData()
      }
    },

    clickItemRight(e, idx) {
      const box = e.target.classList.contains('single') ? e.target : e.target.parentNode
      const dropDom = box.querySelector('.line-drop')
      const wrapRect = this.$refs.ligatureWrap.getBoundingClientRect()
      const dropRect = dropDom.getBoundingClientRect()

      const pos = {
        left: dropRect.left - wrapRect.left + dropRect.width / 2,
        top: dropRect.top - wrapRect.top + dropRect.height / 2,
        direction: 'right',
        key: idx
      }

      const existIndex = this.recordPosition.findIndex(p => p.direction === 'right')
      if (existIndex > -1) {
        this.recordPosition[existIndex] = pos
      } else {
        this.recordPosition.push(pos)
      }

      if (this.recordPosition.length === 2) {
        this.handleLigatureData()
      }
    },

    handleLigatureData() {
      const [pos1, pos2] = this.recordPosition
      const key = `${pos1.direction}-${pos1.key}-${pos2.key}`
      const reverseKey = `${pos2.direction}-${pos2.key}-${pos1.key}`
      if (this.storageLigature.has(key) || this.storageLigature.has(reverseKey)) return

      this.ligature(pos1, pos2)
      const [d, k1, k2] = key.split('-')
      const otherDir = d === 'left' ? 'right' : 'left'
      this.storageLigature.set(key, [this.ligatureList[k1][d], this.ligatureList[k2][otherDir]])

      this.$emit('permissions', true)
      this.limit = 1
      this.studentQuestionResult()
      this.recordPosition = []
    },

    ligature(pos1, pos2, area = '.ligature-list') {
      const centerPos = {
        left: Math.round((pos1.left + pos2.left) / 2),
        top: Math.round((pos1.top + pos2.top) / 2)
      }
      const leftDiff = Math.abs(pos1.left - pos2.left)
      const topDiff = Math.abs(pos1.top - pos2.top)
      const distance = Math.round(Math.sqrt(leftDiff ** 2 + topDiff ** 2))
      const diff = { top: pos1.top - pos2.top, left: pos1.left - pos2.left }
      const rotate = Math.round(Math.atan2(diff.top, diff.left) * (180 / Math.PI))

      const line = document.createElement('div')
      line.className = `line-segment ${pos1.direction}-${pos1.key}-${pos2.key}`
      line.style.width = `${distance}px`
      line.style.top = `${centerPos.top}px`
      line.style.left = `${centerPos.left - distance / 2}px`
      line.style.transform = `rotate(${rotate}deg)`

      document.querySelector(area).appendChild(line)

      if (area === '.ligature-list') {
        line.onclick = () => {
          const key = `${pos1.direction}-${pos1.key}-${pos2.key}`
          this.storageLigature.delete(key)
          document.querySelector(area).removeChild(line)
          this.studentQuestionResult()
        }
      }
    },

    remove() {
      const wrap = this.$refs.ligatureWrap
      const lines = wrap.querySelectorAll('.line-segment')
      for (let i = lines.length - 1; i >= 0; i--) {
        lines[i].remove()
      }
      this.storageLigature.clear()
      this.studentQuestionResult()
      if (this.storageLigature.size === 0) {
        this.$emit('permissions', false)
        this.limit = 0
      }
    },

    initData() {
      this.answer_results = { id: null, student_choices: [] }
      this.recordQuestion = {}
      this.recordPosition = []
      this.storageLigature = new Map()
      this.ligatureList = []
      this.showData = { left: [], right: [] }

      const content = JSON.parse(this.form.content)
      this.ligatureList = content.ligatureList
      content.ligatureList.forEach(item => {
        if (item.left.textValue || item.left.imgValue) this.showData.left.push(item.left)
        if (item.right.textValue || item.right.imgValue) this.showData.right.push(item.right)
      })

      this.resetting(true)
      setTimeout(() => this.showTrueFalse(), 500)
    }
  },
  created() {
    this.initData()
  }
}
</script>

<style scoped lang="scss">
@import url('../../static/pubile.scss');
.question-view {
  width: 700px;
  min-height: 400px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;

  -webkit-touch-callout: none;
  user-select: none;
  overscroll-behavior: none;
  min-height: 0;

  .quest {
    width: 100%;
    height: 100%;
    .title {
      font-size: 15px;
      color: #333;
    }

    .ligature-list {
      width: 330px;
      min-height: 330px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-content: flex-start;
      flex-wrap: wrap;
      position: relative;
      user-select: none;
      /* 核心：完全禁止浏览器默认触摸手势，只交给JS处理 */
      touch-action: none;
      overscroll-behavior: contain;

      .left,
      .right {
        width: 120px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;

        .single {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          cursor: pointer;
          -webkit-tap-highlight-color: transparent;

          .value {
            width: 100px;
            min-height: 45px;
            border-radius: 10px;
            background-color: #fee8d2;
            display: flex;
            align-items: center;
            padding: 5px 10px;
            text-align: center;
            word-wrap: break-word;
            position: relative;
            .span {
              width: 100%;
            }
            &::before {
              content: '';
              position: absolute;
              inset: 0;
              z-index: 1;
            }
          }

          .image {
            width: 100px;
            height: 100px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
          }

          .line-drop {
            width: 10px;
            height: 10px;
            background-color: #d17223;
            border-radius: 50%;
            cursor: pointer;
            position: relative;
            padding: 8px;
            margin: -8px;
            box-sizing: content-box;
            -webkit-tap-highlight-color: transparent;
            /* 圆点也彻底禁止默认手势 */
            touch-action: none;

            &::before {
              content: '';
              position: absolute;
              inset: -2px;
              border-radius: 50%;
              border: 2px solid transparent;
              transition: border 0.5s;
              box-sizing: initial;
            }
          }

          &:hover .line-drop::before {
            border-color: skyblue;
          }
        }
        .select .line-drop::before {
          border-color: skyblue;
        }
        .single:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.line-segment {
  position: absolute;
  height: 2px;
  background-color: #333;
  transform-origin: center center;
  cursor: pointer;
  &:hover {
    background-color: #1a94fa;
  }
}
.line-segment-error {
  background-color: #d60215;
}
.line-segment-success {
  background-color: #007416;
}
.drag-temp-line {
  background: #777;
  background-image: linear-gradient(to right, #777 50%, transparent 50%);
  background-size: 10px 2px;
  pointer-events: none;
}

/* 拖拽期间全局禁止页面弹性滚动/下拉刷新 */
body.ligature-dragging {
  overscroll-behavior-y: none;
  touch-action: none;
}
</style>